import script from "./Student.vue?vue&type=script&setup=true&lang=js"
export * from "./Student.vue?vue&type=script&setup=true&lang=js"

import "./Student.vue?vue&type=style&index=0&id=77d6b450&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77d6b450"]])

export default __exports__